import React, { useEffect, useState } from 'react'
import Login from './components/Login.jsx'
import Admin from './components/Admin.jsx'
import './App.css'

export default function App(){
  const [token, setToken] = useState(localStorage.getItem('admin_token') || '')
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light')

  useEffect(()=> {
    if (token) localStorage.setItem('admin_token', token)
    else localStorage.removeItem('admin_token')
  }, [token])

  useEffect(()=> {
    document.documentElement.setAttribute('data-theme', theme)
    localStorage.setItem('theme', theme)
  }, [theme])

  return token ? (
    <Admin onLogout={() => setToken('')} theme={theme} setTheme={setTheme} />
  ) : (
    <Login onAuthed={(t)=> setToken(t)} theme={theme} setTheme={setTheme} />
  )
}
